import React from "react";
import TabsContainer from "./TabsContainer";
import { useState } from "react";
import RadicalBackground from "./RadicalBackground";
import Terminal from "./Terminal";
import Modular from "./Modular";
import globe from "../assets/globe.gif";
import modular from "../assets/modular.gif";

const Hero = () => {
  return (
    <section className="flex relative flex-col items-center pb-7 max-sm:items-start">
      <div className="flex justify-center items-center w-full h-[493px] max-md:h-[246px] max-sm:h-[430px]">
        <RadicalBackground />
      </div>
      <div className="text-center max-sm:text-left max-sm:ml-5">
        <h1 className="my-6 text-[52px] tracking-tighter text-black max-md:text-[40px] max-md:mb-2 max-sm:text-[32px] max-sm:w-[70%] max-sm:leading-[1.2]">
          OS for Intelligent Machines.
        </h1>
        <p className="text-[24px] text-black font-creato max-md:text-[20px] max-sm:text-[16px] max-sm:w-[70%]">
          Building AI architecture for smart, safe, governable robots
        </p>
      </div>
    </section>
  );
};

const tabData = [
  {
    id: "documents",
    heading: "OM1",
    label: "Documents",
    backgroundColor: "bg-[#FF005F]",
    textColor: "text-white",
    collapsedWidth: "w-[83%]",
    href: "https://docs.openmind.org/home",
  },
  {
    id: "demo",
    heading: "OM1",
    label: "Demo",
    backgroundColor: "bg-[#5BDCC6]",
    textColor: "text-black",
    collapsedWidth: "w-[93%]",
    href: "/demo",
  },
  {
    id: "github",
    heading: "OM1",
    label: "Github",
    backgroundColor: "bg-[#246BEE]",
    textColor: "text-white",
    collapsedWidth: "w-[100%]",
    href: "https://github.com/OpenmindAGI/OM1",
  },
];

const Introducing = () => {
  const [activeTabIndex, setActiveTabIndex] = useState(0);

  const handleTabHover = (tabIndex) => {
    setActiveTabIndex(activeTabIndex === tabIndex ? 0 : tabIndex);
  };

  return (
    <section
      className="flex relative w-full md:h-fit max-sm:flex-col max-sm:h-auto py-12"
      id="om1"
    >
      <TabsContainer
        activeTabIndex={activeTabIndex}
        onTabHover={handleTabHover}
        tabData={tabData}
      />
    </section>
  );
};

const ModularMultiplatformMachine = () => {
  return (
    <section className="flex justify-between h-fit max-sm:flex-col py-12 max-sm:py-0">
      <div className="flex-initiate px-0 py-16 bg-gray-200 rounded-[0px_130.494px_130.494px_0px] w-[50%] w-max-[600px] max-md:w-[50vw] max-md:py-5 max-md:rounded-[0px_50px_50px_0px] max-sm:w-full max-sm:hidden">
        <div className="bg-white h-full w-[calc(100%-60px)] overflow-hidden max-md:w-[calc(100%-20px)]">
          <Modular />
        </div>
      </div>
      <img src={modular} alt="Modular" className="sm:hidden" />
      <div className="flex-grow flex justify-center">
        <div className="pl-5 py-60 pr-35 pb-0 max-w-[500px] max-sm:px-5 max-sm:py-10 max-sm:w-full max-sm:max-w-[400px]">
          <h2 className="mb-5 text-5xl tracking-tighter text-black max-sm:text-4xl max-sm:text-center">
            Modular, Multiplatform, Machine.
          </h2>
          <p className="text-2xl text-black font-creato max-sm:text-lg max-sm:text-center overflow-wrap max-md:w-[85%] max-sm:mx-auto max-sm:leading-[1.15]">
            Easily integrate various LLMs, specialized vision models, and other
            agentic workflow components depending on your use case.
          </p>
        </div>
      </div>
    </section>
  );
};

export default function PlugAndPlay() {
  return (
    <section className="flex flex-col sm:flex-row relative bg-white h-auto py-12">
      <div className="sm:hidden flex justify-center py-20">
        <p className="font-mono text-2xl">uv run src/run.py spot</p>
      </div>
      <div className="flex-1 px-14 py-52 max-w-[496px] max-md:px-5 max-md:py-20 max-sm:max-w-full max-sm:py-5 max-sm:max-w-[70%] max-sm:mx-auto">
        <h2 className="mb-5 text-5xl tracking-tighter text-black max-sm:text-4xl max-sm:text-center">
          Plug & Play
        </h2>
        <p className="mb-12 text-2xl text-black font-creato max-sm:text-lg max-sm:text-center max-sm:w-[80%] max-sm:mx-auto max-sm:leading-[1.15]">
          Easily launch new AI modules and robotic behaviors in minutes; no
          complex setup or heavy refactoring required.
        </p>
        <a
          href="https://github.com/OpenmindAGI/OM1"
          target="_blank"
          rel="noopener noreferrer"
        >
          <button className="px-5 py-2.5 text-2xl text-rose-600 border border-rose-600 border-solid rounded-[39px] w-[350px] max-sm:w-[80%] max-sm:mx-auto max-sm:flex max-sm:justify-center hover:bg-rose-600 hover:text-white transition-colors">
            Start Building
          </button>
        </a>
      </div>
      <div className="flex-1 h-[605px] w-[350px] max-md:mt-10 max-md:h-[50vh] lg:px-10 max-sm:hidden">
        <Terminal />
      </div>
    </section>
  );
}

const Globe = () => {
  return (
    <section className="flex flex-col h-fit py-12 items-center" id="fabric">
      <p className="text-[40px] tracking-[-0.05em] text-black text-center max-md:text-2xl">
        From 1 Robot to 1,000,000
      </p>
      <div className="relative w-[660px] py-12 max-md:w-[330px] max-sm:w-full max-sm:px-10">
        <img className="w-full z-0" src={globe} alt="Globe" />
        <p className="absolute flex inset-0 items-center justify-center tracking-[-0.05em] text-[200px] max-md:text-[110px] max-sm:text-[100px] text-center font-ultralight">
          FABRIC
        </p>
      </div>
      <p className="text-[40px] tracking-[-0.05em] text-black text-center max-md:text-2xl">
        The global machine network.
      </p>
    </section>
  );
};

const Divider = () => (
  <div className="w-[1px] h-[290px] bg-[#A3A3A3] max-sm:hidden max-md:h-[200px]" />
);

const FeatureArticle = ({ title, description }) => (
  <article className="w-full max-md:max-w-[600px] max-sm:text-center max-sm:w-[80%] max-sm:mx-auto">
    <h2 className="mb-4 text-4xl tracking-tighter leading-[115%] text-black max-md:text-[25px] max-sm:w-[70%] max-sm:mx-auto">
      {title}
    </h2>
    <p className="text-[24px] leading-[110%] text-black max-md:text-[18px] font-creato">
      {description}
    </p>
  </article>
);

const FabricFeatures = () => {
  const features = [
    {
      title: "Unified Robotic Collaboration",
      description:
        "Instantly connect heterogenous robots to share data and work on tasks in real-time. FABRIC enables easy cross-vendor integration regardless of tech stack.",
    },
    {
      title: "Personalized Management",
      description:
        "Deploy your own net hub in a dVPN environment, backed by on-chain identities and custom governance. ",
    },
    {
      title: "Diverse Applications",
      description:
        "From drone fleets to AI assistants, FABRIC connects you to specialized solutions and global teams—borderless, seamless collaboration.",
    },
  ];

  return (
    <section className="flex flex-col items-center pt-12">
      <div className="flex gap-11 items-top justify-center mb-24 mx-20 max-md:gap-5 max-md:mx-10 max-sm:flex-col max-sm:gap-16">
        {features.map((feature, index) => (
          <>
            <FeatureArticle key={index} {...feature} />
            {index < features.length - 1 && <Divider />}
          </>
        ))}
      </div>
      {/* <div className="mb-40 text-[40px] leading-[115%] text-black max-w-[1179px] mx-20 font-creato max-md:mx-10 text-left max-md:mb-20 max-md:text-[22px] max-sm:mb-16">
        <p className="mb-10">
          FABRIC provides the fundamental communication and orchestration layer
          for effortlessly unify human &lt;&gt; machine teams.
        </p>
        <p>
          Manage your own Net Hub, define collaboration rules, and instantly
          connect with robots across countless applications.
        </p>
      </div> */}
    </section>
  );
};

export {
  Hero,
  Introducing,
  ModularMultiplatformMachine,
  PlugAndPlay,
  Globe,
  FabricFeatures,
};
